// extracted by mini-css-extract-plugin
export default {"col":"GridCheckboxOptions_col__+0M1y","checkbox_pill":"GridCheckboxOptions_checkbox_pill__+Op3a"};